import { RouteObject } from "react-router-dom";
import { R_PseudoLoginRoutes } from "../../utils/Routes";
import Feature_PseudoLogin from "./Feature_PseudoLogin";

const PseudoLoginRoutes: RouteObject[] = [
  {
    path: R_PseudoLoginRoutes.fromPseudoLogin,
    element: <Feature_PseudoLogin />,
  },
];

export default PseudoLoginRoutes;
